export default "__VITE_ASSET__BJS41BtT__"